import { request } from "../../api";
import { unwrapList } from "../devices";

export interface DeviceGroupRow {
  id: string;
  name: string;
  description: string;
  is_default: boolean;
  is_active: boolean;
  members_count: number;
  rule_usage_count: number;
  created_at: string;
  updated_at: string;
}

export interface DeviceGroupMemberRow {
  id: string;
  device: string;
  device_uid: string;
  platform: string;
  status: string;
  user_email: string | null;
  user_full_name: string | null;
  enrollee_full_name: string | null;
  created_at: string;
}

interface Paginated<T> {
  count?: number;
  next?: string | null;
  previous?: string | null;
  results?: T[];
}

export const deviceGroupsApi = {
  list: async () => {
    const data = await request<Paginated<DeviceGroupRow> | DeviceGroupRow[]>(
      `/api/admin/v1/device-groups/`,
    );
    return unwrapList(data);
  },
  create: (input: { name: string; description?: string; is_active?: boolean }) =>
    request<DeviceGroupRow>(`/api/admin/v1/device-groups/`, {
      method: "POST",
      json: input,
    }),
  patch: (
    id: string,
    body: Partial<{ name: string; description: string; is_active: boolean }>,
  ) =>
    request<DeviceGroupRow>(`/api/admin/v1/device-groups/${id}/`, {
      method: "PATCH",
      json: body,
    }),
  delete: (id: string) =>
    request<undefined>(`/api/admin/v1/device-groups/${id}/`, { method: "DELETE" }),
  listMembers: (id: string) =>
    request<DeviceGroupMemberRow[]>(`/api/admin/v1/device-groups/${id}/members/`),
  addMember: (id: string, body: { device: string }) =>
    request<DeviceGroupMemberRow>(`/api/admin/v1/device-groups/${id}/members/`, {
      method: "POST",
      json: body,
    }),
  removeMember: (id: string, memberId: string) =>
    request<undefined>(
      `/api/admin/v1/device-groups/${id}/members/${memberId}/`,
      { method: "DELETE" },
    ),
};
